/**
 * La compra pendiente que de verdad impide abrir otra. Es la misma regla que
 * `PendingPurchase` en el backend: si aquí dijera otra cosa, el botón estaría
 * habilitado y el servidor contestaría que no, o al revés.
 *
 * Un pago con tarjeta que no se completó no detiene a nadie: la tarjeta se
 * cobra en el momento, así que si vuelve es que abandonó la página. Una
 * referencia SPEI sí, mientras siga vigente, porque puede estar pagándose en
 * su banco.
 */
export function blockingPurchase(pending, now = new Date()) {
  if (!pending) return null;

  const order = pending.paymentOrder;
  if (!order || order.status === "pagada") return pending;

  const expired = order.expiresAt && new Date(order.expiresAt) <= now;
  return order.channel === "tarjeta" || expired ? null : pending;
}

/** Si la compra pendiente es una referencia SPEI que todavía se puede pagar. */
export function isSpeiReference(pending) {
  return pending?.paymentOrder?.channel === "spei";
}

const PAYMENT_STATUS = {
  pendiente: "pendiente",
  pagada: "pagada",
  expirada: "vencida",
};

/**
 * Cómo se pagó una compra, en palabras del contador: «Tarjeta · pagada»,
 * «SPEI · pendiente» o «Transferencia» cuando subió comprobante.
 */
export function paymentLabel(ticket) {
  const order = ticket?.paymentOrder;
  if (!order) return "Transferencia";

  const method = order.channel === "spei" ? "SPEI" : "Tarjeta";
  return `${method} · ${PAYMENT_STATUS[order.status] ?? order.status}`;
}
